/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2023-01-13 17:13:13
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-16 18:01:23
 */
import { mapState } from 'pinia'
import { pinias } from '@main/common/pinia'
import { checkPermi } from '@package/utils'

const { login } = pinias

const PermissionsMixin = {
  computed: {
    ...mapState(login, ['permissionsActions'])
  },
  methods: {
    checkBntPermi(val) {
      return checkPermi(val || '', this.permissionsActions)
    }
  }
}
export default PermissionsMixin
